import { render, staticRenderFns } from "./CuentaPage.vue?vue&type=template&id=e3e38526"
import script from "./CuentaPage.js?vue&type=script&lang=js&external"
export * from "./CuentaPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports